export default __webpack_public_path__ + "static/media/friendsfamily.f4518f2f.pdf";